import { render, staticRenderFns } from "./TeacherRegistComplete.vue?vue&type=template&id=1a87f4e8&"
import script from "./TeacherRegistComplete.vue?vue&type=script&lang=ts&"
export * from "./TeacherRegistComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports